
  import { defineComponent } from 'vue'
  import JQuery from 'jquery'
  const $ = JQuery

  export default defineComponent({
    name: 'Sidebar',
    methods: {
      collapse() {
        const currPos = $('#sidebar-content').css('left')
        if (currPos == '0px') {
          $('#sidebar-content').css('left', '-100vw')
          $('.page-content').css('width', '100vw')
          $('.page-content').css('opacity', '100%')
          $('.page-content').css('visibility', 'visible')
        } else {
          $('#sidebar-content').css('left', '0px')
          $('.page-content').css('width', '0px')
          $('.page-content').css('opacity', '0%')
          $('.page-content').css('visibility', 'hidden')
        }
      },
      callSignOut() {
        this.$store.dispatch('auth/signOut')
      },
    },
  })
